export type Company = {
  id: string;
  name: string;
  website?: string;
  description: string;
  is_active: boolean;
  deleted_at?: string;
  user_id: string;
  created_at: string;
  updated_at: string;
  logo?: string | File;
  email: string;
};

export type Translation = {
  en: string;
  de: string;
};

export const enum JobSalaryMode {
  FIXED = 1,
  RANGE = 2,
  NONE = 3,
}

export type JobCategory = {
  id: string;
  title_translations: Translation;
  slug_translations: Translation;
};
export type TranslatedEntity = {
  id: string;
  title_translations: Translation;
};

export type Currency = {
  id: string;
  code: string;
  order: number;
};

export type JobSalary = {
  id: string;
  job_id: string;
  gross?: number;
  from?: number;
  to?: number;
  mode: number;
  job_salary_period_id?: string;
  currency_id?: string;
  created_at: string;
  updated_at: string;
  period?: TranslatedEntity;
  currency?: Currency;
};

export type JobAddress = {
  id: string;
  job_id: string;
  address_line_1: string;
  address_line_2?: string;
  zip_code: string;
  state?: string;
  city: string;
  country_code: string;
  created_at: string;
  updated_at: string;
  latitude: string;
  longitude: string;
};

export type JobListing = {
  id: string;
  company_id: string;
  job_category_id: string;
  job_employment_type_id: string;
  job_industry_id: string;
  job_type_id: string;
  job_location_id: string;

  title: string;
  short_description?: string;
  start_description: string;
  description: string;
  qualifications: string;
  benefits: string;
  final_description: string;
  link?: string;
  locale: "de" | "en";
  application_end: string;
  is_active: boolean;
  auto_renew: boolean;
  custom_application_link?: string | null;
  recommendable?: boolean;
  distance?: number; // Distance in km
  ai_scanning_enabled?: boolean;

  source: string; // External source when job is imported ("web" when created manually)
  source_id?: string;

  deleted_at?: string;
  created_at: string;
  updated_at: string;
  published_at?: string;
  company: Company;

  job_category: JobCategory;
  job_employment_type: TranslatedEntity;
  job_industry: TranslatedEntity;
  job_type?: { google_type: string } & TranslatedEntity;
  job_location: TranslatedEntity;

  job_salary: JobSalary;

  job_address: JobAddress;
};

export type AiResponse = {
  id: string;
  ai_service: string;
  user_id: string;
  has_error: boolean;
  response: string;
};

const emptyTranslation = {
  id: "",
  title_translations: { en: "", de: "" },
};
export const emptyJob: JobListing = {
  id: "",
  company_id: "",
  job_category_id: "",
  job_employment_type_id: "",
  job_industry_id: "",
  job_type_id: "",
  job_location_id: "",

  title: "",
  short_description: "",
  start_description: "",
  description: "",
  qualifications: "",
  benefits: "",
  final_description: "",
  link: "",
  locale: "de",
  application_end: "",
  is_active: false,
  auto_renew: false,
  recommendable: true,
  custom_application_link: null,
  source: "web",
  ai_scanning_enabled: false,

  deleted_at: "",
  created_at: "",
  updated_at: "",
  published_at: "",
  company: {
    id: "",
    name: "",
    website: "",
    description: "",
    is_active: false,
    deleted_at: "",
    user_id: "",
    created_at: "",
    updated_at: "",
    logo: "",
    email: "",
  },

  job_category: {
    ...emptyTranslation,
    slug_translations: { en: "", de: "" },
  },
  job_employment_type: emptyTranslation,
  job_industry: emptyTranslation,
  job_type: {
    ...emptyTranslation,
    google_type: "",
  },
  job_location: emptyTranslation,

  job_salary: {
    id: "",
    job_id: "",
    gross: 0,
    from: 0,
    to: 0,
    mode: JobSalaryMode.NONE,
    job_salary_period_id: "",
    currency_id: "",
    created_at: "",
    updated_at: "",
    currency: {
      id: "",
      code: "",
      order: 0,
    },
  },

  job_address: {
    id: "",
    job_id: "",
    address_line_1: "",
    address_line_2: "",
    zip_code: "",
    state: "",
    city: "",
    country_code: "",
    created_at: "",
    updated_at: "",
    latitude: "",
    longitude: "",
  },
};
